import { useTranslation } from "src/hooks/translation";
import SuccessStateImage from "src/assets/images/success_state.png";
import SuccessStateImageLight from "src/assets/images/success_state_light.png";
import { useEffect } from "react";
import { useConfig } from "src/hooks/config";
import { useRecoilState } from "recoil";
import mainStore from "src/stores/main";

import "./style.scss";

interface IProps {
	onRepeatBet(): void;
}

const SuccessState = ({ onRepeatBet }: IProps) => {
	const t = useTranslation();
	const config = useConfig();
	const [mainState, setMainState] = useRecoilState(mainStore);

	useEffect(() => {
		setTimeout(() => {
			setMainState(newMainState => ({ ...newMainState, isSuperbet: false, showSuccessState: false }));
		}, config.successStateDelay * 1000);
	}, [config, setMainState]);

	const successText = mainState.isSuperbet
		? "Your superbet has been successfully placed. Good luck! Please remember to take your printed ticket"
		: "Your bet has been successfully placed. Good luck! Please remember to take your printed ticket";

	return (
		<div className="B-betslip-success-state">
			<img src={SuccessStateImage} alt="success state" className="B-success-state-img" />
			<img src={SuccessStateImageLight} alt="success state" className="B-success-state-img-light" />
			<h3>{t("Congratulations")}!</h3>
			<p>{t(successText)}</p>
			<div onClick={onRepeatBet} className="repeat-bet">
				{t("Repeat bet")}
			</div>
		</div>
	);
};

export default SuccessState;
